// **************************************************
// Share
// **************************************************

attachEvent('.mod-share__button', 'click', (ev) => {
  const shareParent = ev.target.closest('.mod-share');
  shareParent.classList.toggle('is-active');
  ev.preventDefault();
});

// *******************************************************************************
// Close Share When Click Out
// *******************************************************************************

document.addEventListener('click', (evt) => {
  const shareEleContainer = document.querySelector('.mod-share__dropdown');
  const shareEleButton = document.querySelector('.mod-share__button');
  let targetElement = evt.target; // clicked element

  do {
    // eslint-disable-next-line max-len
    if (targetElement === shareEleContainer || targetElement === shareEleButton) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  document.querySelectorAll('.mod-share').forEach((el) => {
    el.classList.remove('is-active');
  });
});
